import { DiscussionContextType } from "@cnx/common";
import { create } from "zustand";

interface ChatPanelStore {
  isPanelOpen: boolean;
  panelDiscussionId: string | null;
  panelContextId: string | null;
  panelContext: DiscussionContextType | null;
  setIsPanelOpen: (open: boolean) => void;
  setPanelDiscussionId: (
    discussionId: string | null,
    contextId?: string | null,
    context?: DiscussionContextType | null
  ) => void;
  openDraftDiscussion: (
    context: DiscussionContextType,
    contextId: string
  ) => void;
}

export const useChatPanelStore = create<ChatPanelStore>()(set => ({
  isPanelOpen: false,
  panelDiscussionId: null,
  panelContextId: null,
  panelContext: null,
  setIsPanelOpen: (open: boolean) => set({ isPanelOpen: open }),
  setPanelDiscussionId: (
    discussionId: string | null,
    contextId: string | null = null,
    context: DiscussionContextType | null = null
  ) =>
    set(state => ({
      panelDiscussionId: discussionId,
      panelContextId: contextId,
      panelContext: discussionId === null ? null : context,
      isPanelOpen: discussionId !== null ? true : state.isPanelOpen,
    })),
  openDraftDiscussion: (context: DiscussionContextType, contextId: string) =>
    set({
      panelDiscussionId: null,
      panelContextId: contextId,
      panelContext: context,
      isPanelOpen: true,
    }),
}));
